/**
 * List of stored attribute names for importStudentFields.
 * Prevents the use of magic strings and allows mapping between import fields
 * and postgres values.
 */
export enum EStudentImportAttributeFieldNames {
  ADDRESS_LINE_1 = 'addressLine1',
  ADDRESS_LINE_2 = 'addressLine2',
  ADDRESS_LINE_3 = 'addressLine3',
  AGENT_COMPANY = 'agentCompany',
  AGENT_COMPANY_EMAIL = 'agentCompanyEmail',
  AGENT_EMAIL = 'agentEmail',
  AGENT_NAME = 'agentName',
  AGENT_OFFICE = 'agentOffice',
  APPLICATION_DATE = 'applicationDate',
  APPLICATION_ID = 'applicationId',
  BRANCH_OFFICE = 'branchOffice',
  CITY = 'city',
  COMPANY_NAME = 'companyName',
  CONFIRMED = 'confirmed',
  COUNSELLOR_EMAIL = 'counsellorEmail',
  COUNSELLOR_NAME = 'counsellorName',
  COUNTRY = 'country',
  COUNTRY_OF_BIRTH = 'countryOfBirth',
  CRIMINAL_CONVICTIONS = 'criminalConvictions',
  DOB = 'dob',
  EMAIL = 'email',
  ENGLISH_LEVEL_ATTAINED = 'englishLevelAttained',
  ENGLISH_TEST_PROVIDER = 'englishTestProvider',
  FAMILY_NAME = 'familyName',
  GENDER = 'gender',
  GIVEN_NAME = 'givenName',
  NATIONALITY = 'nationality',
  OTHER_NAME = 'otherName',
  PASSPORT_EXPIRY = 'passportExpiry',
  PASSPORT_NUMBER = 'passportNumber',
  PHONE = 'phone',
  PLACE_OF_BIRTH = 'placeOfBirth',
  POSTCODE = 'postcode',
  PREVIOUS_COURSE_COMPLETION = 'previousCourseCompletion',
  PREV_UK_STUDY = 'prevUKStudy',
  SELT_LISTENING = 'seltListening',
  SELT_READING = 'seltReading',
  SELT_SPEAKING = 'seltSpeaking',
  SELT_WRITING = 'seltWriting',
  STUDENT_NO = 'studentNo',
  UCAS_ID = 'ucasId',
  WITH_AGENT = 'withAgent',
  ADMISSIONS_OFFICE = 'admissionsOffice',
  SERVICES_ASSIGNED = 'servicesAssigned',
  TAGS_ASSIGNED = 'tagsAssigned',
  STAGE = 'stage',
  AGE = 'age',
  VISA_APPLICATION_COUNTRY = 'visaApplicationCountry',
  RISK_REGION = 'riskRegion',
  COURSE_FEE_PAID_TO_DATE = 'courseFeePaidToDate',
  ACCOM_FEE_PAID_TO_DATE = 'accomFeePaidToDate',
  IS_SELT_REQD = 'isSELTReqd',
  REASON_SELT_NOT_REQD = 'reasonSELTNotReqd',
  PREVIOUS_COURSE_LEVEL = 'previousCourseLevel',
  COURSE_PROGRESSION = 'courseProgression',
  PROGRESSION_TEXT = 'progressionText',
  DOCS_USED_TO_OBTAIN_OFFER = 'docsUsedToObtainOffer',
  IS_ACCOM_PROVIDED = 'isAccomProvided',
  IS_ACCOM_INCLUDED_COURSE_FEE = 'isAccomIncludedCourseFee',
  IS_WORK_PLACEMENT = 'isWorkPlacement',
  WORK_PLACEMENT_PERC = 'workPlacementPerc',
  WORK_PLACEMENT_TEXT = 'workPlacementText',
  WORK_PLACEMENT_ADDRESS_LINE_1 = 'workPlacementAddressLine1',
  WORK_PLACEMENT_ADDRESS_LINE_2 = 'workPlacementAddressLine2',
  WORK_PLACEMENT_ADDRESS_LINE_3 = 'workPlacementAddressLine3',
  OFFERS_COURSES_ID = 'offers_courses_id',
  OFFERS_PRESESSIONAL_TITLE = 'offers_presessional_title',
  OFFERS_COURSES_TITLE = 'offers_courses_title',
  OFFERS_COURSES_CONDITIONAL = 'offers_courses_conditional',
  OFFERS_COURSES_DECLINED = 'offers_courses_declined',
  OFFERS_COURSES_CAH3 = 'offers_courses_cah3',
  OFFERS_COURSES_LEVEL = 'offers_courses_level',
  OFFERS_COURSES_SECONDARY_LEVEL = 'offers_courses_secondaryLevel',
  OFFERS_PRESESSIONAL_START_DATE = 'offers_presessional_start_date',
  OFFERS_COURSES_START_DATE = 'offers_courses_start_date',
  OFFERS_PRESESSIONAL_END_DATE = 'offers_presessional_end_date',
  OFFERS_COURSES_END_DATE = 'offers_courses_end_date',
  OFFERS_PRESESSIONAL_FEE = 'offers_presessional_fee',
  OFFERS_COURSES_FEE = 'offers_courses_fee',
  OFFERS_COURSES_SCHOLARSHIP_AMOUNT1 = 'offers_courses_scholarshipAmount1',
  OFFERS_COURSES_SCHOLARSHIP_TITLE1 = 'offers_courses_scholarshipTitle1',
  OFFERS_COURSES_INNER_LONDON = 'offers_courses_inner_london',
  OFFERS_COURSES_LAST_ACCEPTANCE_DATE = 'offers_courses_lastAcceptanceDate',
  OFFERS_COURSES_IS_FULL_TIME = 'offers_courses_isFullTime',
  OFFERS_COURSES_HOURS_PER_WEEK = 'offers_courses_hoursPerWeek',
  OFFERS_COURSES_ATAS = 'offers_courses_atas',
  OFFERS_COURSES_CONDITIONS_TEXT1 = 'offers_courses_conditions_text1',
  OFFERS_COURSES_CONDITIONS_TEXT2 = 'offers_courses_conditions_text2',
  OFFERS_COURSES_CONDITIONS_TEXT3 = 'offers_courses_conditions_text3',
  OFFERS_COURSES_CONDITIONS_TEXT4 = 'offers_courses_conditions_text4',
  OFFERS_COURSES_CONDITIONS_TEXT5 = 'offers_courses_conditions_text5',
  OFFERS_COURSES_CONDITIONS_TEXT6 = 'offers_courses_conditions_text6',
  OFFERS_COURSES_CONDITIONS_TEXT7 = 'offers_courses_conditions_text7',
  OFFERS_COURSES_CONDITIONS_TEXT8 = 'offers_courses_conditions_text8',
  OFFERS_COURSES_CONDITIONS_TEXT9 = 'offers_courses_conditions_text9',
  OFFERS_COURSES_FACULTY = 'offers_courses_faculty',
  MAIN_STUDY_ADDRESS_LINE_1 = 'mainStudyAddressLine1',
  MAIN_STUDY_ADDRESS_LINE_2 = 'mainStudyAddressLine2',
  MAIN_STUDY_ADDRESS_LINE_3 = 'mainStudyAddressLine3',
  MAIN_STUDY_ADDRESS_CITY = 'mainStudyAddressCity',
  MAIN_STUDY_ADDRESS_COUNTRY = 'mainStudyAddressCountry',
  MAIN_STUDY_ADDRESS_POSTCODE = 'mainStudyAddressPostcode',
  WORK_PLACEMENT_ADDRESS_CITY = 'workPlacementAddressCity',
  WORK_PLACEMENT_ADDRESS_COUNTRY = 'workPlacementAddressCountry',
  WORK_PLACEMENT_ADDRESS_POSTCODE = 'workPlacementAddressPostcode',
  OFFERS_COURSES_OFFER_EVIDENCE = 'offers_courses_offerEvidence',
  OFFERS_COURSES_ACCEPTED = 'offers_courses_accepted',
  OFFERS_COURSES_QUAL_HECOS1 = 'offers_courses_qual_hecos1',
  OFFERS_COURSES_QUAL_HECOS2 = 'offers_courses_qual_hecos2',
  OFFERS_COURSES_QUAL_HECOS3 = 'offers_courses_qual_hecos3',
  OFFERS_COURSES_QUAL_HECOS4 = 'offers_courses_qual_hecos4',
  OFFERS_COURSES_QUAL_HECOS5 = 'offers_courses_qual_hecos5',
  OFFERS_COURSES_QUAL_PROPORTION1 = 'offers_courses_qual_proportion1',
  OFFERS_COURSES_QUAL_PROPORTION2 = 'offers_courses_qual_proportion2',
  OFFERS_COURSES_QUAL_PROPORTION3 = 'offers_courses_qual_proportion3',
  OFFERS_COURSES_QUAL_PROPORTION4 = 'offers_courses_qual_proportion4',
  OFFERS_COURSES_QUAL_PROPORTION5 = 'offers_courses_qual_proportion5',
  OFFERS_COURSES_QUAL_CAT = 'offers_courses_qual_cat',
  OFFER_ID = 'offerId',
  INTAKE_ID = 'intakeId',
  UNI_PARTNER_ID = 'uniPartnerId',
  UNI = 'uni',
  PATHWAY = 'pathway',
  EXTERNAL_CAS_STATUS = 'externalCasStatus',
  OFFERS_DURATION_MONTHS = 'offersDurationMonths',
  TUITION_DEPOSIT = 'tuitionDeposit',
  DEPOSIT_AMOUNT = 'depositAmount'
}
